// extracted by mini-css-extract-plugin
export default {"formulario":"FormMVS_formulario__I2Zcd","secao":"FormMVS_secao__S0QDy","campoInput":"FormMVS_campoInput__wunJN"};